export default "__VITE_ASSET__1KFb9nXa__"